/**
 * Report API - Submit NFT and Collection issue reports
 */

import { apiClient } from './client';

// NFT report types
export type NFTReportType =
  | 'incorrect_owner'
  | 'incorrect_offers'
  | 'incorrect_rarity'
  | 'inaccurate_estimated_value';

// Collection report types
export type CollectionReportType =
  | 'incorrect_floor'
  | 'missing_nfts'
  | 'missing_sales_activity'
  | 'incorrect_rarity_rankings';

// Combined type for backwards compatibility
export type ReportType = NFTReportType;

export interface SubmitReportResponse {
  success: boolean;
  message: string;
}

/**
 * Submit a report about an NFT issue
 */
export async function submitNFTReport(
  nftTokenId: string,
  reportType: NFTReportType
): Promise<SubmitReportResponse> {
  return apiClient.post<SubmitReportResponse>('/reports/nft', {
    nftTokenId,
    reportType,
  });
}

/**
 * Submit a report about a Collection issue
 */
export async function submitCollectionReport(
  collectionId: string,
  reportType: CollectionReportType
): Promise<SubmitReportResponse> {
  return apiClient.post<SubmitReportResponse>('/reports/collection', {
    collectionId,
    reportType,
  });
}
